module.exports = __webpack_public_path__ + "static/bb8908148f1ef495950dfc36323c5bdb8e778248b36c54f0f5e30a6d4ac33af6-86d1a8aa7848bb38b47abbafb47637a1.png";